module.exports = __webpack_public_path__ + "img/man.02f60edf.png";